export default __webpack_public_path__ + "static/media/eco.3af30777.png";